<template>
  <div>
    <v-row dense>
      <v-col cols="10">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
      </v-col>
    </v-row>
    <block-od v-bind="$props"/>
    <block-npr v-bind="$props"/>
    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2020</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              НПР
              <div class="little-text ">2020</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2021</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              НПР
              <div class="little-text ">2021</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2022</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              НПР
              <div class="little-text ">2022</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text"> ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8"> n </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg20, 1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')}) }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.wpnpr20,1) }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg21,1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')}) }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.wpnpr21,1) }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg22, 1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')}) }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.wpnpr22, 1) }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text">  ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8">   {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.wpnprQ3, 0, 'integer') }}</span>
        </template>
      </formulsFraction>

      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName+'b022'], item.prd+1, 'float') }}</span>
        </template>
      </formulsFraction>
    </div>
    <p>OДk	-	объем всех поступлений образовательной организации из всех источников в k-ом году</p>
    <p>НПРk	-	численность научно-педагогических (научных) работников в k-ом году</p>
    <p class="mb-4">n	-	число лет, за которые имеются отчетные данные НПРk</p>
    <block-g v-bind="$props"/>
  </div>
</template>

<script>
import BlockOd from "@/components/cards/indicatiors/details/blockOd";
import BlockNpr from "@/components/cards/indicatiors/details/blockNpr";
import BlockG from "@/components/cards/indicatiors/details/blockG";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"

export default {
  name: "a35",
  components: {BlockG, BlockNpr, BlockOd, formulsFraction, formulsFractionSimple},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  methods: {

  },
}
</script>

<style lang="sass" scoped>

</style>